<!-- 
<div *ngIf="lndUserType" class="row">
  <div class="col header">
    <span
      (click)="allLink.home()"
      style="max-width: fit-content; cursor: pointer"
    >
      <i class="fa fa-chevron-left" aria-hidden="true"></i> </span
    >&nbsp;&nbsp;
    <span> List of Claims | {{ user }} Portal </span>
  </div>
  <div class="col header" style="text-align: right">
    <button
      type="button"
      class="btn btn-filter"
      data-bs-toggle="modal"
      data-bs-target="#exampleModal"
    >
      Filter
    </button>
    &nbsp;&nbsp;
    <span *ngIf="filter_value">
      <button type="button" class="btn btn-filter" (click)="clearFilter()">
        Clear
      </button>
    </span>
    <span
      style="font-size: 30px; cursor: pointer; margin-left: 61px"
      (click)="allLink.openNav()"
      >&#9776;
    </span>
  </div>
</div> -->
<span *ngIf="lndUserType">
  <app-header-global></app-header-global>
</span>


<!-- <app-header [allClaimHeading]="headingOne"></app-header> -->

<div class="row allcontent">
  <div [ngClass]="sidebarCollapsed  ? 'col-sm-1 custom_col_1' : 'col-sm-2'">
    <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div [ngClass]="sidebarCollapsed ? 'col-sm-11 custom_col-sm-11' : 'col-sm-10'">

<app-hr-page-header
  [heading]="headingOne"
  [searchPlaceholder]="'Search claims'"
  [showAddButton]="false"
  [showExportButton]="false"
  [initialSearchQuery]="searchQuery"
  [showFilterIcon]="true"
  (searchInput)="onSearchInput($event)"
  (searchFocus)="openFilterDialog()"
  (addClick)="addClaim()"
  (exportClick)="exportClaims()"
  (filterClick)="openFilterDialog()"
></app-hr-page-header>

    <div class="main_claim">
      <div class="detail_claim">
        <div class="radio_btn_section d-flex">
          <div class="radio-btn-section">
            <div class="form-check-inline">
              <label class="form-check-label">
                <input
                class="filter-input"
                  type="radio"
                  class="form-check-input radioinput"
                  name="status"
                  [value]="''"
                  [(ngModel)]="status"
                  (change)="onRadioChange('')"
                  checked
                />
                All
              </label>
            </div>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input
                class="filter-input"
                  type="radio"
                  class="form-check-input radioinput"
                  name="status"
                  [value]="'pending'"
                  [(ngModel)]="status"
                  (change)="onRadioChange('pending')"
                />
                Pending
              </label>
            </div>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input
                class="filter-input"
                  type="radio"
                  class="form-check-input radioinput"
                  name="status"
                  [value]="'rejected'"
                  [(ngModel)]="status"
                  (change)="onRadioChange('rejected')"
                />
                Rejected By HOD
              </label>
            </div>
          </div>
          <div class="filter-btn-section" style="opacity: 0;">
            <button
              type="button"
              class="btn btn-filter"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              Filter
            </button>
            &nbsp;&nbsp;
            <span *ngIf="filter_value">
              <button
                type="button"
                class="btn btn-filter"
                (click)="clearFilter()"
              >
                Clear
              </button>
            </span>

           
          </div>
        </div>
        <div class="claim_div">
          <div class="table-responsive">
            <table class="table" id="emp_expense">
              <thead>
                <tr>
                  <th>Claim ID</th>
                  <th>Submitter</th>
                  <th>Submitter ID</th>
                  <th>CRIS ID</th>
                  <th>Project</th>
                  <th>Legal Entity</th>
                  <th>Date Submitted</th>
                  <th>Expense Type</th>
                  <th>Amount(Total vs Approved)</th>
                  <!-- <th>Amount(Approved)</th> -->
                  <th>Category</th>
                  <th>Reviewer</th>
                  <th>Status</th>
                  <th>Payment Status</th>
                  <th>Manager Approved Date</th>
                  <th>Last Approved Date</th>
                </tr>
              </thead>
              <tbody *ngFor="let data of tableData.length ? tableData : items">
                <!-- [routerLink]="['/detailclaim', data.id]" -->
                <tr (click)="onTableIdClick(data.id)">
                  <td>{{ data.id }}</td>
                  <td>
                    {{ data.submitter.name }} ({{data.submitter.job_title}})
                    
                  </td>
                  <td>{{ data.submitter.emp_id }}</td>
                  <td>{{ data.submitter.sap_id }}</td>
                  <td>{{ data.project.name }}/{{ data.project.amplus_id }}</td>
                  <td>{{ data.submitter.legal_entity }}</td>
                  <td>{{ data.submitted_at }}</td>
                  <td>{{ data.expense_type }}</td>
                  <td>{{ data.amount }}/--{{ data.approved_amount }}</td>
                  <td>{{ data.category.name }}</td>
                  <td>{{ data.reviewer.name }}</td>
                  <td>{{ data.status }}</td>
                  <td>{{ data.payment_status }}</td>
                  <td>{{ data.manager_approved_date }}</td>
                  <td>{{ data.last_approved_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="page_div">
            <div class="row" id="pagination-container">
              <div class="col-sm-5 text-left">
                Current Page {{ this.currentPage }} Total Number of Pages
                {{ this.totalPages }}
              </div>
              <div class="col-sm-7 text-right" style="text-align: right;">
                <button
                  (click)="previousPage()"
                  class="btn custom-btn"
                  [disabled]="this.currentPage === 1 || this.totalPages<1"
                >
                  <<
                </button>
                <button
                  (click)="firstPage()"
                  class="btn custom-btn"
                  [disabled]="this.currentPage === 1 || this.totalPages<1"
                >
                  First
                </button>
                <ng-container *ngIf="totalPages > 0">
                  <button
                    *ngFor="let page of getNumericButtons()"
                    (click)="gotoPage(page)"
                    class="btn custom-btn"
                    [class.active]="page === currentPage"
                  >
                    {{ page }}
                  </button>
                </ng-container>
                <button
                  (click)="lastPage()"
                  class="btn custom-btn"
                  [disabled]="this.currentPage === this.totalPages || this.totalPages <1"
                >
                  Last
                </button>
                <button
                  (click)="nextPage()"
                  class="btn custom-btn"
                  [disabled]="this.currentPage === this.totalPages || this.totalPages<1"
                >
                  >>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="pagination_div"></div> -->

    <!-- <pagination-controls (pageChange)="p=$event"></pagination-controls> -->
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog filter-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header dialog-header">
            <h5 class="modal-title dialog-title" id="exampleModalLabel">Filters</h5>
            <button
              type="button"
              class="close allclaimPopup close-btn cross_btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form (ngSubmit)="_filterData()">
            <div class="modal-body dialog-content">
              <div class="filter-field">
                <label class="filter-label" for="name">Submitter's Name</label>
                <input
                  class="filter-input"
                  type="text"
                  [(ngModel)]="uname"
                  name="uname"
                  autocomplete="off"
                  placeholder="Enter Name"
                />
              </div>
              
              <div class="filter-field">
                <label class="filter-label" for="Email">Submitter's Email</label>
                <input
                  class="filter-input"
                  type="text"
                  [(ngModel)]="uemail"
                  name="uemail"
                  autocomplete="off"
                  placeholder="Enter Email"
                />
              </div>
              
              <div class="filter-field">
                <label class="filter-label" for="pcode">Project Code</label>
                <input
                  class="filter-input"
                  type="text"
                  [(ngModel)]="pcode"
                  name="pcode"
                  autocomplete="off"
                  placeholder="Enter Project Code"
                />
              </div>
              
              <div class="filter-field">
                <label class="filter-label" for="claimid">Claim Id</label>
                <input
                  class="filter-input no-spinner"
                  type="number"
                  [(ngModel)]="claimid"
                  name="claimid"
                  autocomplete="off"
                  placeholder="Enter Claim Id"
                  appOnlyNumbers
                />
              </div>
              
              <div class="filter-field">
                <label class="filter-label" for="legal_entity">Legal Entity</label>
                <select
                  class="filter-input"
                  name="legalentity"
                  [(ngModel)]="legalentity"
                  id="legal_entity"
                >
                  <option [value]="''">Select Legal Entity</option>
                  <option *ngFor="let legalentitydata of ledata" [value]="legalentitydata">
                    {{ legalentitydata }}
                  </option>
                </select>
              </div>
              
              <div class="filter-field">
                <label class="filter-label" for="approvedDate">Last Approved Date</label>
                <div class="inputdivs">
                  <input
                    class="filter-input dateinput"
                    matInput
                    [matDatepicker]="picker"
                    placeholder="dd-mm-yyyy"
                    autocomplete="off"
                    name="approvedDate"
                    [(ngModel)]="approvedDate"
                    (click)="picker.open()"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker panelClass="lastapproved-datepicker-panel"></mat-datepicker>
                </div>
              </div>
              
              <div class="filter-field">
                <div class="outeremp">
                  <input
                    type="checkbox"
                    id="outer-emp"
                    name="external"
                    [(ngModel)]="external"
                    #externalCheckbox
                    (change)="externalValue(externalCheckbox.checked)"
                  />
                  <label class="filter-label" for="outer-emp">Third Party Claims</label>
                </div>
              </div>
            </div>
            
            <div class="modal-footer dialog-actions">
              <button
                type="button"
                (click)="_clearData()"
                class="btn btn-secondary"
              >
                 Remove All Filters 
              </button>
              <button
                type="submit"
                class="btn btn-primary"
              >
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>


  </div>
</div>
